$(document).ready(function () {
  function updatePrice(multiplier) {
    $(".price__default .price__current, .price.price--top .price__current").each(function () {
      // $(this) parent class was not
      if ($(this).parent().hasClass("price__no-variant")) {
      } else {
        var price = $(this).text();
        //var price = '£14.00';

        // moneyFormat = '£{{amount}}'

        // i want price 1.2 with moneyFormat = '£{{amount}}'

        // get price without currency
        var priceWithoutCurrency = price.replace(/[^0-9.-]+/g, "");
        // get currency
        var currency = price.replace(priceWithoutCurrency, "");
        // get price without currency
        var priceWithoutCurrency = parseFloat(priceWithoutCurrency);
        // get price with currency and make max decimal 2
        
        var priceWithCurrency =
          currency + (priceWithoutCurrency * multiplier).toFixed(2);
        priceWithCurrency = priceWithCurrency.replace(/\s/g, "");
        // set price with currency
        $(this).text(priceWithCurrency);
      }
    });
  }

  $(document).on(
    "change",
    '.toggle-tax .switch-tax input[type="checkbox"]',
    function () {
      // If checked, apply tax (multiply by 1.2), else remove tax (divide by 1.2)
      if ($(this).is(":checked")) {
        updatePrice(1 / 1.2); // Remove tax by dividing by 1.2
      } else {
        updatePrice(1.2); // Apply 1.2x for tax
      }
    }
  );

  // Initialize vertical thumbnail gallery functionality
  function initVerticalThumbnails() {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const verticalThumbs = mediaGallery.querySelectorAll('.media-thumbs-vertical .media-thumbs__btn');
    const mainViewer = mediaGallery.querySelector('#gallery-viewer');
    const mediaItems = mediaGallery.querySelectorAll('.media-viewer__item');
    const thumbSlider = mediaGallery.querySelector('.media-thumbs-vertical-slider');
    const thumbContainer = mediaGallery.querySelector('.media-thumbs-vertical');
    const upArrow = mediaGallery.querySelector('.thumb-nav-up');
    const downArrow = mediaGallery.querySelector('.thumb-nav-down');
    const prevBtn = mediaGallery.querySelector('.media-ctrl__btn[name="prev"]');
    const nextBtn = mediaGallery.querySelector('.media-ctrl__btn[name="next"]');
    
    if (!verticalThumbs.length || !mainViewer || !mediaItems.length || !thumbSlider) return;

    let currentThumbIndex = 0;
    const visibleThumbs = 5;
    const thumbHeight = 100; // 88px + 12px gap
    const totalThumbs = verticalThumbs.length;

    // Initialize thumbnail slider
    function initThumbSlider() {
      if (totalThumbs <= visibleThumbs) {
        // Hide arrows if all thumbnails fit
        if (upArrow) upArrow.style.display = 'none';
        if (downArrow) downArrow.style.display = 'none';
        return;
      }

      // Show arrows if needed
      if (upArrow) upArrow.style.display = 'flex';
      if (downArrow) downArrow.style.display = 'flex';
      
      updateThumbSliderPosition();
      updateArrowStates();
    }

    // Update slider position
    function updateThumbSliderPosition() {
      const translateY = -currentThumbIndex * thumbHeight;
      thumbSlider.style.transform = `translateY(${translateY}px)`;
    }

    // Update arrow states
    function updateArrowStates() {
      if (upArrow) {
        upArrow.disabled = currentThumbIndex === 0;
      }
      if (downArrow) {
        downArrow.disabled = currentThumbIndex >= totalThumbs - visibleThumbs;
      }
    }

    // Auto-scroll thumbnails to center the active thumbnail
    function autoScrollToActiveThumbnail(activeIndex) {
      if (totalThumbs <= visibleThumbs) return;

      // Calculate the center position - we want the active thumbnail in the middle (position 2 of 5)
      const centerPosition = Math.floor(visibleThumbs / 2); // This is 2 for 5 visible thumbnails
      let targetScrollIndex = activeIndex - centerPosition;

      // Ensure we don't scroll past the boundaries
      targetScrollIndex = Math.max(0, targetScrollIndex);
      targetScrollIndex = Math.min(totalThumbs - visibleThumbs, targetScrollIndex);

      currentThumbIndex = targetScrollIndex;
      updateThumbSliderPosition();
      updateArrowStates();
    }

    // Update active thumbnail based on main gallery
    function updateActiveThumbnail() {
      // Find the currently visible/active media in the main gallery
      let currentMediaId = null;
      
      // Method 1: Check for is-current-variant class
      const currentVariantMedia = mainViewer.querySelector('.media-viewer__item.is-current-variant');
      if (currentVariantMedia) {
        currentMediaId = currentVariantMedia.dataset.mediaId;
      }
      
      // Method 2: If no current variant, find the most visible media item in viewport
      if (!currentMediaId) {
        const viewerRect = mainViewer.getBoundingClientRect();
        const viewerCenter = viewerRect.left + viewerRect.width / 2;
        let closestDistance = Infinity;
        let closestMedia = null;
        
        mediaItems.forEach(item => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(itemCenter - viewerCenter);
          
          if (distance < closestDistance) {
            closestDistance = distance;
            closestMedia = item;
          }
        });
        
        if (closestMedia) {
          currentMediaId = closestMedia.dataset.mediaId;
        }
      }

      if (!currentMediaId) return;

      const activeThumbIndex = Array.from(verticalThumbs).findIndex(thumb => {
        return thumb.closest('.media-thumbs__item').dataset.mediaId === currentMediaId;
      });

      if (activeThumbIndex !== -1) {
        // Remove active state from all thumbnails
        verticalThumbs.forEach(t => {
          t.classList.remove('is-active');
          t.removeAttribute('aria-current');
        });
        
        // Add active state to current thumbnail
        const activeThumb = verticalThumbs[activeThumbIndex];
        activeThumb.classList.add('is-active');
        activeThumb.setAttribute('aria-current', 'true');
        
        // Auto-scroll to center the active thumbnail
        autoScrollToActiveThumbnail(activeThumbIndex);
      }
    }

    // Arrow click handlers
    if (upArrow) {
      upArrow.addEventListener('click', function() {
        if (currentThumbIndex > 0) {
          currentThumbIndex--;
          updateThumbSliderPosition();
          updateArrowStates();
        }
      });
    }

    if (downArrow) {
      downArrow.addEventListener('click', function() {
        if (currentThumbIndex < totalThumbs - visibleThumbs) {
          currentThumbIndex++;
          updateThumbSliderPosition();
          updateArrowStates();
        }
      });
    }

    // Listen for main gallery navigation - Enhanced detection
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        setTimeout(updateActiveThumbnail, 150);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        setTimeout(updateActiveThumbnail, 150);
      });
    }

    // Listen for main gallery scroll changes
    if (mainViewer) {
      let scrollTimeout;
      mainViewer.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveThumbnail, 100);
      });
    }

    // Listen for any clicks within the main gallery
    if (mainViewer) {
      mainViewer.addEventListener('click', function() {
        setTimeout(updateActiveThumbnail, 150);
      });
    }

    // Listen for variant changes on the entire media gallery
    if (mediaGallery) {
      mediaGallery.addEventListener('change', function() {
        setTimeout(updateActiveThumbnail, 150);
      });
    }

    // Observe changes to ALL media items for any class changes
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        setTimeout(updateActiveThumbnail, 50);
      }
    });

    mediaItems.forEach(item => {
      observer.observe(item, { 
        attributes: true, 
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true
      });
    });

    // Listen for keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        setTimeout(updateActiveThumbnail, 150);
      }
    });

    // Listen for touch/swipe events on mobile
    let touchStartX = 0;
    if (mainViewer) {
      mainViewer.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
      });
      
      mainViewer.addEventListener('touchend', function(e) {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > 50) { // Significant swipe
          setTimeout(updateActiveThumbnail, 150);
        }
      });
    }

    // Thumbnail click handlers
    verticalThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Get the media ID from the parent li
        const mediaId = this.closest('.media-thumbs__item').dataset.mediaId;
        
        // Find the corresponding media item in the main viewer
        const targetMedia = mainViewer.querySelector(`[data-media-id="${mediaId}"]`);
        
        if (targetMedia) {
          // Remove active state from all thumbnails
          verticalThumbs.forEach(t => {
            t.classList.remove('is-active');
            t.removeAttribute('aria-current');
          });
          
          // Add active state to clicked thumbnail
          this.classList.add('is-active');
          this.setAttribute('aria-current', 'true');
          
          // Auto-scroll to keep active thumbnail visible
          autoScrollToActiveThumbnail(index);
          
          // Remove current variant class from all media items
          mediaItems.forEach(item => {
            item.classList.remove('is-current-variant');
          });
          
          // Add current variant class to target media
          targetMedia.classList.add('is-current-variant');
          
          // Scroll target media into view if using stacked layout
          const layout = mediaGallery.dataset.layout;
          if (layout === 'stacked') {
            targetMedia.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest',
              inline: 'center'
            });
          } else {
            // For slider layout, scroll to the target
            const targetIndex = Array.from(mediaItems).indexOf(targetMedia);
            if (targetIndex !== -1) {
              const scrollLeft = targetIndex * targetMedia.offsetWidth;
              mainViewer.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
              });
            }
          }
          
          // Update counter if it exists
          const counterCurrent = mediaGallery.querySelector('.media-ctrl__current-item');
          if (counterCurrent) {
            const targetIndex = Array.from(mediaItems).indexOf(targetMedia) + 1;
            counterCurrent.textContent = targetIndex;
          }
          
          // Update navigation button states
          updateNavButtons(mediaGallery, Array.from(mediaItems).indexOf(targetMedia));
        }
      });
    });

    // Initialize the slider and set initial active thumbnail
    initThumbSlider();
    setTimeout(updateActiveThumbnail, 200);
    
    // Periodic sync check to ensure thumbnails stay in sync
    setInterval(updateActiveThumbnail, 1000);
  }

  // Update navigation button states
  function updateNavButtons(mediaGallery, currentIndex) {
    const prevBtn = mediaGallery.querySelector('.media-ctrl__btn[name="prev"]');
    const nextBtn = mediaGallery.querySelector('.media-ctrl__btn[name="next"]');
    const mediaItems = mediaGallery.querySelectorAll('.media-viewer__item');
    
    if (prevBtn) {
      prevBtn.disabled = currentIndex === 0;
    }
    
    if (nextBtn) {
      nextBtn.disabled = currentIndex === mediaItems.length - 1;
    }
  }

  // Initialize on DOM ready
  setTimeout(initVerticalThumbnails, 100);
  
  // Re-initialize when variant changes or product updates
  document.addEventListener('variant:change', function() {
    setTimeout(initVerticalThumbnails, 100);
  });
  document.addEventListener('product:updated', function() {
    setTimeout(initVerticalThumbnails, 100);
  });
  
  // Re-initialize when media gallery loads
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initVerticalThumbnails, 200);
  });
});
